module.exports = __webpack_public_path__ + "static/media/logo-gray.db1c4c7d.jpg";